import React, { SVGProps } from "react";

export default function SupChevronUpCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.99999 6.21897L15.3841 12.6799L14.6159 13.3201L9.99999 7.78102L5.3841 13.3201L4.61588 12.6799L9.99999 6.21897Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM2.8 10C2.8 6.02355 6.02355 2.8 10 2.8C13.9764 2.8 17.2 6.02355 17.2 10C17.2 13.9764 13.9764 17.2 10 17.2C6.02355 17.2 2.8 13.9764 2.8 10Z"
        fill="currentColor"
      />
    </svg>
  );
}
